import type { ResultHandlerProps, SearchResult } from '../../types';

import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginate, {
  PaginationProvider,
  PaginationListStandalone
} from 'react-bootstrap-table2-paginator';

// import svg from '../../utils/checkmark.svg';
import ShowIf from '../ShowIf';

import './styles.scss';

const columns = [
  // {
  //   dataField: 'score',
  //   text: 'Relevance',
  //   headerStyle: { width: 96 },
  //   sort: true
  // },
  {
    dataField: 'ss_field_report_number',
    text: 'Number',
    headerStyle: { width: 105 },
    sort: true,
    formatter: function formatNumber(cell: unknown, row: any) {
      return <p>{row.ss_field_report_number}</p>;
    }
  },
  {
    dataField: 'bs_field_do_not_seal',
    text: 'Report',
    sort: false,
    headerStyle: { width: 152 },
    formatter: function formatSealed(cell: unknown, row: any) {
      const nid = row.its_nid;
      const attachments = row.its_field_report_pdf ?? [];
      const attachment = attachments ? (
        <a className="btn btn-primary" href={`/report/download/${nid}`}>
          <i className="fa-duotone fa-lg fa-file-pdf"></i> Report PDF
        </a>
      ) : null;

      const sealed = (
        <a className="btn btn-primary" href={`/stateselect/${nid}`}>
          <i className="fa-duotone fa-lg fa-file-certificate"></i> Sealed PDF
        </a>
      );

      return row.bs_field_do_not_seal ? (
        <div className="btn-group-vertical">{attachment}</div>
      ) : (
        <div className="btn-group-vertical">
          {attachment}
          {sealed}
        </div>
      );
    }
  },
  {
    dataField: 'bs_field_legacy_document',
    sort: true,
    text: 'Title',
    formatter: function formatTitle(cell: unknown, row: any) {
      const legacy = row.bs_field_legacy_document ? (
        <span className="badge bg-danger ms-1">Legacy</span>
      ) : null;
      //console.log(row);
      return (
        <p>
          <a className="" href={`/node/${row.its_nid}`}>
            {row.tm_X3b_und_title} {row.tm_X3b_en_title} {legacy}
          </a>
        </p>
      );
    }
  },
  {
    dataField: 'tm_X3b_und_client_reference',
    text: 'Report Holder',
    formatter: function formatClientLinks(cell: unknown, row: any) {
      const clients_und = row.tm_X3b_und_client_reference;
      const clients_en = row.tm_X3b_en_client_reference;
      let clients = clients_und;
      if (
        typeof row.tm_X3b_und_client_reference !== 'undefined' &&
        typeof row.tm_X3b_en_client_reference !== 'undefined'
      ) {
        clients = [
          ...row.tm_X3b_und_client_reference,
          ...row.tm_X3b_en_client_reference
        ];
      } else if (typeof row.tm_X3b_en_client_reference !== 'undefined') {
        clients = clients_en;
      } else {
        clients = clients_und;
      }
      const nids = row.itm_field_client_reference;
      const companylist = [];
      for (const [index, value] of clients.entries()) {
        companylist.push(
          <li key={`${index}`}>
            <a className="client" href={`/node/${nids[index]}`}>
              {value}
            </a>
          </li>
        );
      }
      return <ul>{companylist}</ul>;
    }
  },
  {
    dataField: 'tm_X3b_und_product_reference',
    text: 'Product Name',
    formatter: function formatClientLinks(cell: unknown, row: any) {
      const products_und = row.tm_X3b_und_product_reference;
      const products_en = row.tm_X3b_en_product_reference;
      let products = products_und;
      if (
        typeof row.tm_X3b_und_product_reference !== 'undefined' &&
        typeof row.tm_X3b_en_product_reference !== 'undefined'
      ) {
        products = [
          ...row.tm_X3b_und_product_reference,
          ...row.tm_X3b_en_product_reference
        ];
      } else if (typeof row.tm_X3b_en_product_reference !== 'undefined') {
        products = products_en;
      } else {
        products = products_und;
      }
      const nids = row.itm_field_product_reference;
      const productlist = [];
      for (const [index, value] of products.entries()) {
        productlist.push(
          <li key={`${index}`}>
            <a className="client" href={`/node/${nids[index]}`}>
              {value}
            </a>
          </li>
        );
      }
      return <ul>{productlist}</ul>;
    }
  }
];

export default function SearchResults(
  props: ResultHandlerProps<SearchResult>
): JSX.Element {
  const { pagination, results, sort } = props;
  const start = pagination.total
    ? pagination.perPage * (pagination.page - 1) + 1
    : 0;
  const end = Math.min(start + pagination.perPage - 1, pagination.total);

  return (
    <PaginationProvider
      pagination={paginate({
        custom: true,
        page: pagination.page,
        sizePerPage: pagination.perPage,
        hideSizePerPage: true,
        totalSize: pagination.total,
        onPageChange: pagination.onChange
      })}
    >
      {({ paginationProps, paginationTableProps }: any) => {
        return (
          <div className="search-results">
            <ShowIf value={props.options.resultCount}>
              <p className="result-count">
                Showing results {start}-{end} of {pagination.total}.
              </p>
            </ShowIf>
            <BootstrapTable
              remote
              keyField="item_id"
              data={results}
              columns={columns}
              onTableChange={(type, props) => {
                switch (type) {
                  case 'pagination': {
                    pagination.onChange(props.page);
                    break;
                  }
                  case 'sort': {
                    sort.onChange({
                      field: props.sortField,
                      direction: props.sortOrder
                    });
                    break;
                  }
                }
              }}
              sorted={
                sort.field && sort.direction
                  ? [{ dataField: sort.field, order: sort.direction }]
                  : []
              }
              {...paginationTableProps}
            />
            <div className="pagination-container">
              <PaginationListStandalone {...paginationProps} />
            </div>
          </div>
        );
      }}
    </PaginationProvider>
  );
}
